module.exports = __webpack_public_path__ + "02_medium_gold.4f0bfac7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/02_medium_gold.png
// module id = Kl3z
// module chunks = 0